import { render } from "./ArticlePost.vue?vue&type=template&id=2e39606c"
import script from "./ArticlePost.vue?vue&type=script&lang=js"
export * from "./ArticlePost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__